module.exports = __webpack_public_path__ + "static/gelatinous_cube-6aff77f4e5cab0443510c35db3d8f170.jpeg";